import React from "react";
import ReactDOM from "react-dom";
import "./FloorPlan.scss";
import classnames from "classnames";
import { applyRoom } from "../../pages/area/util";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import api from "../../lib/api";
import masterData from "../../lib/masterData";
import { Link } from "../../lib/Link";

export class FloorPlan extends React.Component {

  state = {};
  selectFloor(floor) {
    this.setState({ floor, metrics: null, room: null });
  }

  clickRoomImage(e, room) {
    e.stopPropagation();
    if (room) {
      const margin = 0;
      const width = 400;
      const height = room.campaignPrice ? (room.devBiko ? 318 : 273) : (room.devBiko ? 288 : 238);
      const metrics = { width: width, height: height };
      const target = e.target;
      const wrapper = target.closest(".madoriImg");
      const centerY = target.offsetTop + target.offsetHeight / 2;
      const centerX = target.offsetLeft + target.offsetWidth / 2;
      if (centerY < wrapper.clientHeight / 2) {
        metrics.top = target.offsetTop + target.offsetHeight + margin;
      } else {
        metrics.top = target.offsetTop - metrics.height - margin;
      }
      if (centerX < wrapper.clientWidth / 2) {
        metrics.left = target.offsetLeft + target.offsetWidth + margin;
      } else {
        metrics.left = target.offsetLeft - metrics.width - margin;
      }
      this.setState({ metrics, room });
    } else {
      this.setState({ metrics: null, room: null });
    }
  }

  render() {
    const { asset, type } = this.props;
    const campaign = masterData.campaign.byId[asset.primaryCampaign || asset.campaigns && asset.campaigns[0]];
    const currentFloor =
      (asset.floorBySlug && asset.floorBySlug[this.state.floor]) ||
      (asset.floors && asset.floors[0]);
    const rooms =
      currentFloor &&
      asset.rooms &&
      asset.rooms.filter(room => {
        if (currentFloor.floorId !== room.floor) {
          return false;
        }
        if (!masterData.vacant.showInFloorPlan(room.vacant)) {
          return false;
        }
        return true;
      });

    if(type == TYPE_SP){
      return null;
    }

    const pref = masterData.pref.byId[asset.pref];
    const prefSlug = pref ? pref.slug : '';

    const roomLabel = (room) => {
      if (room.flTxt) {
        return (
          <span className="roomItemHeaderRight">{room.flTxt.replace(/[（）]/g, '')}</span>
        );
      } else if (room.productTypeTxt) {
        return (
          <span className="roomItemHeaderRight">{room.productTypeTxt.replace(/[（）]/g, '')}</span>
        );
      } else {
        return null;
      }
    }

    return (
      <div className="room_list floor_plan">
        <div className="title"><h3>間取り</h3></div>
        <div className="data_header">
          {asset.floors &&
            asset.floors.map(({ floorId }) => (
              <div
                className={classnames("item link", {
                  active: currentFloor.floorId === floorId,
                })}
                key={floorId}
                onClick={() => {
                  this.selectFloor(floorId);
                }}
              >
                {floorId}階
              </div>
            ))}
        </div>
        <div className="data_content">
          <div className="floor_plan_content">
          {(() => {
            if (currentFloor) {
              return currentFloor.floorImg.sort().map((img) => {
                return (
                  <div
                    className="madoriImg link"
                    onClick={e => this.clickRoomImage(e, null)}
                  >
                    <img src={api.madorizuImageUrl(img)} alt ={asset.name + "_間取り"}/>
                    <div>
                      {rooms &&
                        rooms.map(room => {
                          if (room.floorImg !== img) {
                            return null;
                          }
                          return (
                            <div
                              className={ room.campaignPrice ? "aki_c" : "aki" }
                              key={room.roomId}
                            >
                              <div
                                className="link"
                                style={room.style}
                                onClick={e => this.clickRoomImage(e, room)}
                                onMouseOver={e => this.clickRoomImage(e, room)}
                              />
                            </div>
                          );
                        })}
                    </div>
                    {this.state.metrics && this.state.room.floorImg == img && (
                      <div className="floorPopup" style={this.state.metrics}>
                        {this.state.room.campaignPrice && campaign && <div className="campain link" >
                          <Link to="#campaign_detail">キャンペーン中！</Link>
                        </div>}
                        <table
                          cellSpacing="0"
                          cellPadding="0"
                          border="0"
                          className="tooltipInnerDetail ui table"
                        >
                          <tbody>
                            <tr>
                              <th width="150">広さ</th>
                              <td>{this.state.room.extentName} </td>
                            </tr>
                            <tr>
                              <th>階数</th>
                              <td>{roomLabel(this.state.room)}{this.state.room.floor}階</td>
                            </tr>
                            <tr>
                              <th>幅･奥行き･高さ（約）</th>
                              <td>
                                {this.state.room.width}×{this.state.room.depth}×
                                {this.state.room.height}
                              </td>
                            </tr>
                            <tr>
                              <th>使用料（毎月・税込）</th>
                              <td>
                                <p className="dTchargeNew2">
                                  <span>{(this.state.room.price).toLocaleString()}円</span>
                                </p>
                              </td>
                            </tr>
                            {this.state.room.devBiko &&
                            <tr>
                              <th>備考</th>
                              <td>
                                <div className={this.state.room.devBiko.length >= 20 ? "scroll" : ""}>
                                <p className="dTchargeNew2" style={this.state.room.devBiko.length < 15 ? {"font-size": "100%", "letter-spacing": "0em"} :
                                  (this.state.room.devBiko.length < 18 ? {"font-size": "80%", "letter-spacing": "0em"} :
                                  (this.state.room.devBiko.length < 20 ? {"font-size": "60%", "letter-spacing": "0em"} : {}) : {}) }>
                                  <span>{this.state.room.devBiko}</span>
                                </p>
                                </div>
                              </td>
                            </tr>}
                            {this.state.room.opimages.length != 0 &&
                            <tr>
                              <th>写真</th>
                              <td>
                                <ul>
                                  {this.state.room.opimages.map((opimage,index) => {
                                      return(
                                        <li>
                                          <img style={{ "height": "50%" }} src={api.roomOpImageUrl(asset.assetId, this.state.room.roomId, opimage)}/>
                                          {this.state.room.opimagesComment[index] &&
                                            <p>{this.state.room.opimagesComment[index]}</p>
                                          }
                                        </li>
                                      );
                                    })
                                  }   
                                </ul>
                              </td>
                            </tr>}
                          </tbody>
                        </table>
                        <div className="collection">
                          {this.state.room.vacant == 0 &&
                          <div
                            className="item link"
                            onClick={() => {
                              applyRoom(this.state.room, asset, type, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                            }}
                          >
                            お申し込み
                          </div>}
                          {!asset.disableEstimation &&
                          <div
                            className="item link"
                            onClick={() =>
                              modal.openModal("modal_estimate", {
                                room: this.state.room,
                                asset,
                              })
                            }
                          >
                            見積もり
                          </div>}
                        </div>
                      </div>
                    )}
                  </div>
                );
              });
            }
          })()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/detail/FloorPlan.jsx